import appConfig from '../../config/appConfig';
import ClientsideFacilities from '@/api/ClientsideFacilities';
import AssetTypes from '../../api/AssetTypes';

const tableData = {
  namespaced: true,
  state: {
    operationalUSProjects: undefined,
    developmentUSProjects: undefined,
    operationalCanadaProjects: undefined,
    developmentCanadaProjects: undefined,
    allProjects: undefined,
    allCanadaProjects: undefined,
    allUSProjects: undefined,
    tableDataLoaded: false
  },
  mutations: {
    setOperationalUSProjects: (state, projects) => {
      state.operationalUSProjects = projects;
    },
    setOperationalCanadaProjects: (state, projects) => {
      state.operationalCanadaProjects = projects;
    },
    setDevelopmentUSProjects: (state, projects) => {
      state.developmentUSProjects = projects;
    },
    setDevelopmentCanadaProjects: (state, projects) => {
      state.developmentCanadaProjects = projects;
    },
    setAllProjects: (state, projects) => {
      state.allProjects = projects;
    },
    setAllCanadaProjects: (state, projects) => {
      state.allCanadaProjects = projects;
    },
    setAllUSProjects: (state, projects) => {
      state.allUSProjects = projects;
    },
    setTableDataLoaded: (state, value) => {
      state.tableDataLoaded = value;
    }
  },
  getters: {
    operationalUSProjects: (state) => {
      return state.operationalUSProjects;
    },
    operationalCanadaProjects: (state) => {
      return state.operationalCanadaProjects;
    },
    developmentUSProjects: (state) => {
      return state.developmentUSProjects;
    },
    developmentCanadaProjects: (state) => {
      return state.developmentCanadaProjects;
    },
    allProjects: (state) => {
      return state.allProjects;
    },
    allCanadaProjects: (state) => {
      return state.allCanadaProjects;
    },
    allUSProjects: (state) => {
      return state.allUSProjects;
    },
    tableDataLoaded: (state) => {
      return state.tableDataLoaded;
    }
  },
  actions: {
    async updateTableData({ commit, state, getters, rootGetters }) {
      const updateData = async () => {
        const profileLoaded = rootGetters['profileConfig/profileLoaded'];
        const assetTypes = rootGetters['filterData/assetTypes'];
        if (profileLoaded) {
          //TODO: Need a better universal way to get facility layer data than assuming we have a map.
          const facilityLayer = rootGetters['mapTemplate/facilityFeatureLayer'];
          const facilities = new ClientsideFacilities(
            appConfig.facilityApiProps
          );
          const data = await facilities.getFacilityTableData(facilityLayer);
          if (data && data !== null) {
            const allProjects = await facilities.sortFacilityTableData(
              data,
              assetTypes
            );
            commit('setAllProjects', allProjects);

            const USAll = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] === 'USA'
              );
            });
            const USAllAssets = await facilities.sortFacilityTableData(
              USAll,
              assetTypes
            );
            commit('setAllUSProjects', USAllAssets);

            const CanadaAll = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] ===
                  'Canada'
              );
            });
            const CanadaAllAssets = await facilities.sortFacilityTableData(
              CanadaAll,
              assetTypes
            );
            commit('setAllCanadaProjects', CanadaAllAssets);

            const USOps = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] ===
                  'USA' &&
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.statusTypeField] ==
                  'Operational'
              );
            });
            const USOpsAssets = await facilities.sortFacilityTableData(
              USOps,
              assetTypes
            );
            commit('setOperationalUSProjects', USOpsAssets);

            const CandaOps = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] ===
                  'Canada' &&
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.statusTypeField] ==
                  'Operational'
              );
            });
            const CanadaOpsAssets = await facilities.sortFacilityTableData(
              CandaOps,
              assetTypes
            );
            commit('setOperationalCanadaProjects', CanadaOpsAssets);

            const USDev = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] ===
                  'USA' &&
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.statusTypeField] ==
                  'Development/Construction'
              );
            });
            const USDevAssets = await facilities.sortFacilityTableData(
              USDev,
              assetTypes
            );
            commit('setDevelopmentUSProjects', USDevAssets);

            const CanadaDev = data.filter((f) => {
              return (
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.countryField] ===
                  'Canada' &&
                f.attributes[appConfig.facilityApiProps.countryField] &&
                f.attributes[appConfig.facilityApiProps.statusTypeField] ==
                  'Development/Construction'
              );
            });
            const CanadaDevAssets = await facilities.sortFacilityTableData(
              CanadaDev,
              assetTypes
            );
            commit('setDevelopmentCanadaProjects', CanadaDevAssets);
          }
          commit('setTableDataLoaded', true);
        }
      };
      updateData();
    }
  }
};

export default tableData;
